import React, { Component } from 'react';
import { useState } from 'react';
import TabComponent from '../TabComponent';
import DatePicker from '../DatePicker';
import TimePicker from '../TimePicker';
import Calendar from '../Calendar';
import { withStore } from '../store';
import MultiDropDown from '../MultiDropDown/MultiDropDown';
import Alert from '../Alert';
import { alertNotValid } from '../alerts'
import Loader from '../Loader';
import InputWithClearButton from '../InputWithClearButton';
import EventCalendar from '../event/EventCalendar';
import { Helper } from '../Helper';
import { Service } from '../ApiService';
import { createValidators } from '../storeValidatorsRules'

import StatusDeletedSVG from '../../svg/StatusDeletedSVG';

import DeleteUpSVG from '../../svg/DeleteUpSVG'
import SaveUpSVG from '../../svg/SaveUpSVG'
import ReturnUpSVG from '../../svg/ReturnUpSVG'
import CheckBox from '../CheckBox';
import MemberEventOrders from './MemberEventOrders';




class MemberEvent extends Component {

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();
        let evtId = 0;
        let userEventId = 0;
        let fromAdminPage = false;
        if (props.match.params.id) {
            evtId = props.match.params.id
        }
        else {
            evtId = props.location.state.eventId;
            userEventId = props.location.state.userEventId;
            fromAdminPage = props.location.state.fromAdminPage;
        }
        this.state = {
            repeatedEventsIsOpen: true,
            activeTabIndex: 0,
            loading: evtId !== 0,
            eventMain: {
                eventId: evtId,
                userId: '',
                name: "",
                dates: [],
                memberDates: [],
                userEventId: userEventId,
                gracePricePeriod: 0,
                userCompany: ''
            },
            fromAdminPage: fromAdminPage,
            eventId: evtId,
            showError: false,
            showDialog: false,
            showMessage: false,
            showPromptDialog: false,
        };
        this.dayDropDownRef = null;
        this.numberDropDownRef = null;
        //this.timeFromDropDownRef = null;
        //this.timeToDropDownRef = null;
        //this.dateStartDropDownRef = null;
        //this.dateEndDropDownRef = null;
        this.chaptersDropDownRef = null;
        this.typeOfEventDropDownRef = null;
        this.nextStep = this.nextStep.bind(this);
        this.updateEvent = this.updateEvent.bind(this);
        this.updateEventProperty = this.updateEventProperty.bind(this);
        this.setActiveStep = this.setActiveStep.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.emptyTitle = false;
        this.emptyChapter = false;
        this.emptyStartDate = false;
        //this.emptyTimeFrom = false;
        //this.emptyTimeTo = false;
        this.emptyType = false;
        this.headerText = '';
    }

    memberEventValidators = () => createValidators([
        { 'name': 'memberDates', 'typeFunction': 'eventCalendarValue', 'text': 'dates' },
    ]);

    componentWillMount() {
        this.validators = this.memberEventValidators();
        this.alertNotValid = alertNotValid(() => this.setState({ showError: false }));
    }

    componentWillReceiveProps(props) {
        this.setDefaultChapter(props);
    }

    setDefaultChapter(props) {
        if (props.store.userInfo != null && this.state.eventId == 0 && props.store.userInfo.authType == "Secretary") {
            var temp = this.state.eventMain;
            temp.site = props.store.userInfo.chapterId;
            this.setState({ eventMain: temp });
        }
    }

    componentDidMount() {
        this.setDefaultChapter(this.props);
        if (this.props.location && this.props.location.state && this.props.location.state.date) {
            var temp = this.state.eventMain;
            temp.date = this.props.location.state.date;
            this.setState({ eventMain: temp });
        }
        var component = this;

        if (this.state.eventId == 0 && this.state.eventMain.userEventId == 0) {
            this.headerText = 'Error!';
            this.dialogText = "";
            this.dialogContent = <h4>Failed to load event</h4>
            this.mode = 'error';
            this.setState({ loading: false, showMessage: true });
        }
        else if (this.state.eventMain.userEventId != 0) {
            Service.getMemberEventByUserEventId(this.state.eventMain.userEventId)
                .then(data => {

                    component.setState({ eventMain: data, loading: false });
                })
                .catch(exception => component.setState({ error: exception, loading: false }));
        }
        else if (this.state.eventId != 0) {
            Service.getMemberEvent(this.state.eventId)
                .then(data => {
                    
                    component.setState({ eventMain: data, loading: false });
                })
                .catch(exception => component.setState({ error: exception, loading: false }));
        }
    }

    updateEvent() {
        var event = Object.assign({}, this.state.eventMain);
        event.eventId = this.state.eventId;
        this.setState({ loading: true });
        return Service.changeMemberEvent(event)
            .then(data => {
                if (data.success === false) {
                    this.setState({ loading: false, showError: true });
                    return Promise.reject(new Error('Failed to update event'));
                }
                else if (data.success === true) {
                    return data.data;
                }
                else return data;
            });
    }

    onSaveClick() {
        let save = () => { 
            this.updateEvent().then((data) => {
                /* SHOW SUCCESS MESSAGE */
                this.headerText = 'Hurray!';
                this.dialogText = "Information was successfully saved for the event";
                this.dialogContent = <h4>{this.state.eventMain.name}</h4>
                this.mode = 'success'
                this.setState({ loading: false, showMessage: true });
            })/*.catch(()=>{/* show Error Window *//*})*/
        }
        this.performIfValid(() => save(), () => this.setState({showError: true}) );
    }

    setActiveStep(num) {
        var me = this;
        var afterStep = (data) => {

            var eventMain = { ...this.state.eventMain };
            eventMain.userEventId = data.userEventId;

            me.setState({ activeTabIndex: num, eventId: data.eventId, eventMain: eventMain, loading: false });
        }

        let updateEvent = () => {
            this.updateEvent().then((data) => {
                if (data)
                    afterStep(data);
            }, (rejection) => {
                    console.log(rejection);
            });
        }

        switch (this.state.activeTabIndex) {
            case 0:
                updateEvent();
                break;
            default:
                this.setState({ activeTabIndex: num });
        }
    }


    nextStep() {
        this.setActiveStep(this.state.activeTabIndex + 1);
    }

    onTestChange(newVal){
        var tmp = this.state.eventMain;
        tmp.test = newVal;
        this.setState({eventMain:tmp});
    }

    updateEventProperty(property, value, comparator) {
        var temp = {...this.state.eventMain};
        if (Array.isArray(temp[property])) {
            let arr = [...temp[property]];
            var foundIndex = arr.findIndex(dt => {
                if (comparator && typeof comparator === 'function') {
                    return comparator(dt, value);
                }
                else {
                    return dt === value;
                }
            });
            if (foundIndex >= 0) {
                arr.splice(foundIndex, 1);
            }
            else {
                arr.push(value);
            }
            temp[property] = arr;
        }
        else {
            temp[property] = value;
        }
        this.setState({ eventMain: temp });
    }

    onPublishButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'published';
            this.updateEvent().then(data => {
                this.setState({ eventMain: data, showDialog: false, loading: false });
            });
        };
        let publish = () => {
            this.headerText = 'Publish';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "Are you sure you want to publish event?";
            this.dialogContent = <h4>{this.state.eventMain.name}</h4>
            this.setState({showDialog: true});
        }
        this.performIfValid(() => publish(), () => this.setState({showError: true}) );
    }

    onCancelEventButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'canceled';
            this.updateEvent().then(data => {
                this.setState({ eventMain: data, showDialog: false, loading:false });
            });
            
        };
        let cancel = () => {
            this.headerText = 'Cancel';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "Are you sure you want to cancel event?";
            this.dialogContent = <h4>{this.state.eventMain.name}</h4>
            this.setState({showDialog: true});
        }
        this.performIfValid(() => cancel(), () => this.setState({showError: true}) );
    }

    onDeleteEventButtonClick() {
        let onOkButtonClick = () => {
            let event = this.state.eventMain;
            event.eventStatus = 'deleted';
            this.setState({ loading:true });
            this.updateEvent().then(data => {
                this.setState({ 
                    eventMain: data, 
                    showDialog: false, 
                    /*loading:false */
                }, () => this.props.history.goBack());
            });
        };
        let del = () => {
            this.headerText = 'Delete';
            this.onOkButtonClick = onOkButtonClick;
            this.dialogText = "";
            this.dialogContent = <div><h4>{this.state.eventMain.name}</h4><p className='m-05'>Are you sure you want to unattend this event?</p></div>
            this.setState({showDialog: true});
        }
        let checkIfEventHasID = () => {
            if(this.state.eventId === 0){this.props.history.goBack()}
            else del();
        }
        this.performIfValid(() => del(), checkIfEventHasID);
    }

    renderHeader() {
        if (this.state.fromAdminPage) {
            return (<div>
                <h1 className='uppercase-text mb-05'>SIGN UP FOR<strong> {this.state.eventMain.name}</strong></h1>
                <h4 className='uppercase-text mb-2'>{this.state.eventMain.userCompany}</h4>
            </div>)
        }

        return (<h1 className='uppercase-text mb-2'>ATTEND<strong> {this.state.eventMain.name}</strong></h1>)
    }

    performIfValid(callback, errorCallback) {
        if (this.props.store.isFormValid(this.validators, this.state.eventMain)) {
            callback()
        } 
        else { 
            if (errorCallback) { errorCallback()} 
        };
    }

    onSetDayTimesClick(dayIndex) {
        let date = this.state.eventMain.dates[dayIndex];

        const updateTempTime = (from, to, callback) => {
            var temp = { ...this.state.eventMain };
            temp.tempTimeFrom = from;
            temp.tempTimeTo = to;
            this.setState({ eventMain: temp }, () => {
                if (callback) callback();
            });
        }

        updateTempTime(date.timeFrom, date.timeTo, () => {

            let onOkButtonClick = () => {
                var temp = { ...this.state.eventMain };

                var dates = [...this.state.eventMain.dates];
                let date = dates[dayIndex];
                date.timeFrom = this.state.eventMain.tempTimeFrom;
                date.timeTo = this.state.eventMain.tempTimeTo;
                temp["dates"] = dates;
                this.setState({ eventMain: temp, showPromptDialog: false });
            };

            this.headerText = 'Please pick event time period';
            this.dialogText = "";
            this.onOkButtonClick = onOkButtonClick;

            this.setState({ showPromptDialog: true });
        });
    }

    getTabToRender = () => {
        switch (this.state.activeTabIndex) {
            case 0: return this.getMainTab();
            case 1: return this.getOrdersTab();
            default: return '';
        }
    }

    getMainTab = () => {
        const user = this.props.store.userInfo;
        return <ul className='input-fields first-child-text-60 mt-1 pl-1 pr-1'>
            <li>
                <p>Event:</p>
                <p className='label'>{this.state.eventMain.name}</p>
            </li>
            <li
                className={this.emptyStartDate ? 'mark-invalid' : ''}
                error-text='Please enter the date range'
            >
                <p>Dates:</p>
                <div className={this.props.store.checkIfShowError('memberDates', this.validators) ? 'error-input-wrapper' : ""}>
                    <EventCalendar
                        ref={el => this.eventCalendarRef = el}
                        dates={this.state.eventMain.memberDates}
                        allowedDates={this.state.eventMain.dates}
                        useTime={false}                        
                        minDate={new Date()}
                        onSetDayTimesClick={this.onSetDayTimesClick.bind(this)}
                        onSelect={date => {
                            //if (user.authType == 'Admin') {
                            //    return;
                            //}

                            this.emptyStartDate = false;
                            this.props.store.updateValidators("memberDates", date, this.validators);
                            var newObj = {
                                date: date,
                                timeFrom: {
                                    activated: false,
                                    hours: 8,
                                    minutes: 0,
                                    am: true,
                                },
                                timeTo: {
                                    activated: false,
                                    hours: 10,
                                    minutes: 0,
                                    am: true,
                                },
                            };
                            this.updateEventProperty("memberDates", newObj, (obj1, obj2) => Helper.AreDatesEqual(obj1.date, obj2.date));
                        }}
                    />
                    {this.props.store.displayValidationErrors('memberDates', this.validators)}
                </div>
            </li>
        </ul>
    }

    getOrdersTab = () => {
        const user = this.props.store.userInfo;
        return <MemberEventOrders
            userEventId={this.state.eventMain.userEventId}
            eventId={this.state.eventId}
            editsPermitted={user} //&& this.state.eventMain.memberDates.filter((elem) => Helper.CompareDates(elem.date, new Date()) > 0).length > 0}
        />
    }

    render() {
        const user = this.props.store.userInfo;
        let eventStatus = this.state.eventMain.eventStatus;
        if (eventStatus === undefined) {eventStatus = "draft"}
        //const pictures = this.state.formattedPicturesList;

        let tabToRender = this.getTabToRender();

        return (
            <div className='pages-wsm-wrapper ipw-800'>
                <div className='second-nav-wrapper'>
                    <div className='ipw-600'>
                        <div className='flex-nowrap align-center'>
                            {/*eventStatus !== 'deleted' && this.state.activeTabIndex == 0 && user && user.authType != 'Admin' &&
                                <button 
                                    className='round-button medium-round-button outline-on-hover hlo500'
                                    onClick = {() => this.onDeleteEventButtonClick()}
                                    hint="Delete"
                                >
                                    <DeleteUpSVG />
                                    <span>Delete</span>
                                </button>
                            */}
                            {this.state.activeTabIndex == 0 && user &&
                                <button
                                    className='round-button medium-round-button outline-on-hover hlo500'
                                    hint="Save"
                                    onClick={this.onSaveClick}
                                >
                                    <SaveUpSVG />
                                    <span>Save</span>
                                </button>
                            }
                            <button
                                className='round-button medium-round-button outline-on-hover hlo500'
                                hint="Exit"
                                onClick={() => this.props.history.goBack()}
                            >
                                <ReturnUpSVG />
                                <span>Exit</span>
                            </button>
                        </div>
                    </div>
                </div>
                {this.state.loading && <Loader/>}
                {this.renderHeader()}
                <div className = 'flex-wrap flex-flow-column mb-3'>
                    <TabComponent 
                        fixedHeight={true}
                        tabList={['information', 'service orders']}
                        wasSelected={(index) => this.performIfValid(() => this.setActiveStep(index), () => this.setState({showError: true}) )}
                        activeTabIndex={this.state.activeTabIndex}
                    />
                </div>

                {tabToRender}

                <div className='flex-wrap mt-2'>
                    {this.state.activeTabIndex > 0 &&
                        <button 
                            className='medium-static-button static-button' 
                            onClick={() => this.performIfValid(() => this.setActiveStep(this.state.activeTabIndex-1), () => this.setState({showError: true}) )}
                        >Back</button>
                    }
                    {this.state.activeTabIndex < 1 &&
                        <button 
                            className='medium-static-button static-button default-button' 
                            onClick={() => this.performIfValid(this.nextStep, () => this.setState({showError: true})) }
                        >Next</button>
                    }
                </div>
                
                {this.state.showError && this.alertNotValid }

                {this.state.showPromptDialog &&
                    <Alert
                        headerText={this.headerText}
                        text={this.dialogText}
                        onClose={() => this.setState({ showDialog: false })}
                        showOkCancelButtons={true}
                        onCancelButtonClick={() => this.setState({ showDialog: false })}
                        onOkButtonClick={() => this.onOkButtonClick()}
                        cancelButtonText="Cancel"
                        okButtonText="Ok"
                        mode='warning'
                    >
                    <div>
                        <TimePicker
                            //ref={timeFromPicker}
                            timePickerMode={true}
                            value={this.state.eventMain.tempTimeFrom}
                            style={{ fontSize: "0.8rem" }}
                            onChange={(time) => {

                                //if (value.activated) { this.emptyTimeFrom = false; }
                                //this.props.store.updateValidators("timeFrom", value, this.validators);
                                this.updateEventProperty("tempTimeFrom", time);

                                //updateTempTime(time, this.state.eventMain.tempTimeTo);

                                //timeFromPicker.current.setValueManually(time);
                                //this.props.store.updateValidators("timeFrom", value, this.validators);
                                //this.updateEventProperty("timeFrom", time);

                            }}
                        />
                        <TimePicker
                            //ref={timeToPicker}
                            timePickerMode={true}
                            value={this.state.eventMain.tempTimeTo}
                            style={{ fontSize: "0.8rem" }}
                            onChange={(time) => {
                                this.updateEventProperty("tempTimeTo", time);

                                //updateTempTime(this.state.eventMain.tempTimeFrom, time);
                                //this.state.eventMain.tempTimeTo = time;
                                //timeFromPicker.current.setValueManually(time);
                            }}
                        />
                        {/*<button text="OK" onClick={() => { }} />
                        //onOkButtonClick(timeFromPicker.current.value, timeToPicker.current.value)} />*/}
                    </div>
                    </Alert>
                }

                {this.state.showDialog && 
                    <Alert 
                        headerText = {this.headerText}
                        text = {this.dialogText}
                        onClose = {() => this.setState({showDialog: false})}
                        showOkCancelButtons = {true}
                        onCancelButtonClick = {() => this.setState({showDialog: false})}
                        onOkButtonClick = {() => this.onOkButtonClick()}
                        cancelButtonText = "Cancel"
                        okButtonText = "Ok"
                        mode = 'warning'
                    >
                       {this.dialogContent}
                    </Alert>
                }

                {this.state.showMessage && 
                    <Alert 
                        headerText = {this.headerText}
                        text = {this.dialogText}
                        onClose = {() => this.setState({showMessage: false})}
                        showOkButton = {true}
                        onOkButtonClick = {() => this.setState({showMessage: false})}
                        okButtonText = "Ok"
                        mode = {this.mode}
                    >
                       {this.dialogContent}
                    </Alert>
                }
            </div>
        );
    }
}

export default withStore(MemberEvent);


// WEBPACK FOOTER //
// ./src/components/member/MemberEvent.jsx